<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    @success="loaded"
  >
    <view-container
      class="view-product-upsell"
      title="Configure sua área de membros"
      :breadcrumbs="breadcrumbs"
      header
      content-header
    >
      <template #header>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <product-dropdown v-if="product" :product="product" />
          <button
            v-if="product && product.is_blitz_members"
            class="btn btn-40 btn-link btn-new-link d-none d-lg-block"
            @click="openClubLogged"
          >
            Acessar área de membros
            <i
              class="ml-5 fa-solid fa-arrow-up-right-from-square font-weight-bold"
            ></i>
          </button>
        </div>
      </template>

      <template
        #responsive-header-button
        v-if="product && product.is_blitz_members"
      >
        <button
          class="btn btn-40 btn-link btn-new-link mr-5"
          @click="openClubLogged"
        >
          Acessar área de membros
          <i
            class="ml-5 fa-solid fa-arrow-up-right-from-square font-weight-bold"
          ></i>
        </button>
      </template>

      <template #content-header>
        <div class="row justify-content-between align-items-center mb-5">
          <div class="col-lg-6">
            <div class="view-title">
              Configure sua área de membros
            </div>
          </div>
          <div class="col-lg-6">
            <div class="d-flex justify-content-end align-items-center">
              <b-form-checkbox
                id="is-blitz-members"
                v-model="isBlitzMembers"
                switch
                :disabled="!subdomain"
              >
                Ativar área de membros
              </b-form-checkbox>
              <bp-tooltip
                v-if="!subdomain"
                text="Cadastre um subdomínio para ativar sua área de membros"
              >
                <span class="danger-info-circle ml-3 mb-lg-3">!</span>
              </bp-tooltip>
            </div>
          </div>
        </div>
      </template>

      <action-dispatcher
        action="membersSetup/get"
        :parameters="$route.params.id"
      >
        <setup :setup="setup" />
      </action-dispatcher>
    </view-container>
  </action-dispatcher>
</template>

<script>
import { BpTooltip } from "@/components/designSystem/";
import ProductDropdown from "@/components/product/ProductDropdown.vue";
import Setup from "@/components/product/details/content/Setup";
import MemberAreaMixin from "@/mixins/memberArea.js";
import { mapState } from "vuex";

export default {
  components: { Setup, ProductDropdown, BpTooltip },
  mixins: [MemberAreaMixin],
  data() {
    return {
      isBlitzMembers: false
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersSetup", ["setup"]),
    subdomain() {
      return this.setup?.subdomain;
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        { title: "Configurar área de membros" }
      ];
    }
  },
  watch: {
    isBlitzMembers(v) {
      this.$store
        .dispatch("product/put", {
          id: this.$route.params.id,
          is_blitz_members: v
        })
        .then(({ data }) => this.$store.commit("product/setProduct", data));
    }
  },
  methods: {
    loaded() {
      this.isBlitzMembers = this.product.is_blitz_members;
    }
  }
};
</script>
<style lang="scss" scoped>
.view-product-upsell {
}
</style>
